export const PrivacyPolicyPage = () => {
  return (
    <section className="min-h-[70vh] bg-cream py-20" data-testid="privacy-policy-page">
      <div className="container-custom max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-forest mb-8">Privacy Policy</h1>
        <div className="space-y-6 text-forest/80 leading-relaxed">
          <p>
            Warner Digital Media respects your privacy. This policy explains what information we collect,
            how we use it, and how we protect it.
          </p>
          <p>
            We may collect contact details you submit through forms (such as name, email, and message)
            to respond to your inquiries and provide our services.
          </p>
          <p>
            We do not sell your personal information. We only share information with trusted providers when
            necessary to operate our website or deliver services.
          </p>
          <p>
            If you have questions about this policy or your data, contact us through the contact page.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyPage;
